import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import { navItems } from '.';
import PropTypes from 'prop-types';



const itemStyles = makeStyles(theme => ({
  root: {
    textDecoration: 'none',
    color: '#1a1a1a',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  text: {
    marginLeft: theme.spacing(2),
    fontSize: 18
  },
  selected: {
    color: theme.palette.primary.main
  }
}));

function NavItem(props) {
  const { url, title, icon, selected } = props;
  const classes = itemStyles();

  return (
    <Link
      to={url}
      className={`${classes.root} ${selected && classes.selected}`}
    >
      {icon}

      <Typography
        variant='h4'
        className={classes.text}
      >
        {title}
      </Typography>
    </Link>
  );
}

NavItem.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.element,
  selected: PropTypes.bool
}



const mainStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  }
}));

function SideNav(props) {
  const { business } = props;
  const classes = mainStyles();
  const location = useLocation();

  const end = location.pathname.split('/')[3];
  const path = end ? `/${end}` : '';

  return (
    <div className={classes.root}>
      {navItems.map(item => (
        <NavItem
          key={item[0]}
          url={`/business/${business.url || business.id}${item[1]}`}
          title={item[0]}
          icon={item[2]}
          selected={path === item[1]}
        />
      ))}
    </div>
  );
}

SideNav.propTypes = {
  business: PropTypes.object
}




export default SideNav;
